export default __webpack_public_path__ + "static/164_te_loomis-5014.png";